import { Form, FormProps, Input, Button } from "antd";
import { InputProps, SearchProps } from "antd/es/input";
import { ButtonProps } from "antd/es";
import { isMobile } from "react-device-detect";


export interface SearchInputProps extends Omit<SearchProps, 'enterButton'|'onSearch'|'size'|'variant'|'form'> {
	name: string;
	buttonText: string;
	
	onSearch: SearchProps['onSearch'];
	
	size?: InputProps['size'];
	variant?: InputProps['variant'];
	
	form?: FormProps['form'];
	
	formProps?: Omit<FormProps, 'form'>;
}



export default function SearchInput({
	name,
	buttonText,
	onSearch,
	size = 'large',
	variant = 'outlined',
	form = undefined,
	formProps = {},
	...searchProps
}: SearchInputProps) {
	const buttonVariantsMap: Record<Exclude<typeof variant, null|undefined>, ButtonProps['variant']> = {
		borderless: 'text',
		filled: 'solid',
		outlined: 'outlined',
		underlined: 'outlined',
	};
	
	return (<>
		<Form className="form_search_horizontal" autoComplete="off" {...formProps}>
			<Form.Item name={name} className={!isMobile ? 'item_search' : 'item_search_mobile'}>
				<Input.Search
					allowClear
					maxLength={255}
					
					{...searchProps}
					
					size={size}
					variant={variant}
					enterButton={
						<Button
							size={size}
							color="default"
							variant="outlined"
							disabled={searchProps?.disabled}
							style={{
								background: '#fff',
								color : '#000',
								borderColor: '#d9d9d9',
								boxShadow: 'none'
							}}
						>
							{buttonText}
						</Button>
					}
					onSearch={onSearch}
				/>
			</Form.Item>
		</Form>
	</>);
}